import React from 'react';

import Card from 'crm/elements/common/Card';
import Row, { TableDetailsBody } from 'crm/elements/common/TableDetailsRow';

function PaymentMethodChannelDetails({ paymentMethodChannel }) {
    const { name, payment_method, logo_url, order, created_at } = paymentMethodChannel;

    return (
        <Card title="Payment Method Channel details">
            <TableDetailsBody>
                <Row label="Name">{name}</Row>
                <Row label="Payment Method Name">{payment_method && payment_method.name}</Row>
                <Row label="Logo Image" showIf={!!logo_url}>
                    <img alt="" src={logo_url} className="w-100" />
                </Row>
                <Row label="Order">{order}</Row>
                <Row label="Created At">{created_at}</Row>
            </TableDetailsBody>
        </Card>
    );
}

export default PaymentMethodChannelDetails;
